module.exports = __webpack_public_path__ + "img/warehouse.33451dea.png";